import { useState } from "react";
import { useDispatch } from "react-redux";
import useUserInfo from "../../hooks/useUserInfo";
import ButtonLoader from "../../Loader/student/ButtonLoader";
import { useGetAssignmentAndMarkQuery } from "../../redux/features/assignment/assignmentApi";
import { addNotification } from "../../redux/features/notification.js/notificationSlice";
import Modal from "../ui/Modal/Modal";
import AssignmentSubmit from "./AssignmentSubmit";


export default function AssignmentButtonInPlayer({ videoId }) {
    const dispatch = useDispatch();
    const user = useUserInfo();
    const [isModal, setModal] = useState(false);
    const { data, isLoading, isError, refetch } = useGetAssignmentAndMarkQuery({ videoId, studentId: user?.id })

    const handleOut = () => {
        setModal(false)
    }


    // set notification for refresh
    const handleRequest = (newData) => {
        if (newData?.status === "fulfilled") {
            dispatch(addNotification({
                message: "Refreshed successfully",
                type: "success"
            }))
        }
        else if (newData?.status === "rejected") {
            dispatch(addNotification({
                message: "Refresh Request Failed",
                type: "rejected"
            }))
        }

    }

    const handleRefetch = () => {
        refetch().then(handleRequest)
    }
    // decide what to render 
    let content = null;
    if (isLoading) { content = <ButtonLoader /> }
    if (!isLoading && isError) { content = null }
    if (!isLoading && !isError && data?.isAssignment) {
        const { assignment, isAssignmentMark, assignmentMark } = data;
        content =
            <> {isAssignmentMark ?
                <>
                    <button
                        className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
                        {`সর্বমোট নাম্বার- ${assignment?.totalMark}`}
                    </button>

                    {assignmentMark?.status === "pending" ? <button
                        className={`group px-3 font-bold py-1 border border-cyan rounded-full text-sm bg-orange-600 text-primary relative`}>
                        প্রাপ্ত নাম্বার- "PENDING"
                        <span onClick={handleRefetch} disabled={isLoading}
                            className={`absolute hidden cursor-pointer group-hover:block w-full top-0 left-0 px-3 font-bold py-1 border border-cyan rounded-full text-sm bg-gray-600 text-primary`}>
                            Refresh
                        </span>
                    </button> :
                        <button
                            className={`px-3 font-bold py-1 border border-cyan rounded-full text-sm bg-green-600 text-primary`}>
                            প্রাপ্ত নাম্বার- {assignmentMark?.mark}
                        </button>
                    }




                </> :

                <button onClick={() => setModal(true)}
                    className="px-3 font-bold py-1 border border-cyan text-cyan rounded-full text-sm hover:bg-cyan hover:text-primary">
                    এসাইনমেন্ট জমা দিন
                </button>
            }

                {
                    isModal &&

                    <Modal width={"w-[400px] lg:w-[600px]"} handleOut={handleOut}>
                        <AssignmentSubmit handleOut={handleOut} assignment={assignment} />
                    </Modal>

                }
            </>

    }

    return content
};